import * as t from 'ts-codec';
export const PaginatedRequest = t.object({
    cursor: t.string.optional(),
    limit: t.number.optional()
});
export const PaginatedResponse = (codec) => {
    return t.object({
        items: t.array(codec),
        more: t.boolean,
        cursor: t.string.optional()
    });
};
